import * as React from 'react'
import { Link } from 'react-router-dom'
import { Carousel } from 'antd'
import { Image } from '@ui-pc'
import { getRelativeUrl } from '@utils/index'
import styles from './index.module.scss'
interface Props {
  list: any[]
}
const SecondCategory: React.FunctionComponent<Props> = ({ list }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    arrows: list?.length > 9,
    nextArrow: (
      <a className={`${styles['slider-button']} ${styles['slider-next']}`}>
        <i className="iconfont icon-right"></i>
      </a>
    ),
    prevArrow: (
      <a className={`${styles['slider-button']} ${styles['slider-prev']}`}>
        <i className="iconfont icon-left"></i>
      </a>
    )
  }
  return (
    <>
      <div
        className={`second-category-wrap ${styles['second-category-wrap']} ${
          list?.length <= 9 ? styles['no-carousel'] : ''
        }`}>
        <Carousel {...settings}>
          {list?.map((item: any, index: number) => {
            return (
              <Link
                key={index}
                className={styles['second-child-item']}
                to={getRelativeUrl(item.jumpUrl)}>
                {/*去圣诞 <div className={styles['dhat']}></div> */}
                <div className={styles['img-wrap']}>
                  <Image
                    preview={false}
                    src={item.categoriesIcon || 'void'}
                    className={styles['cate-img']}></Image>
                </div>
                <p className={styles['cate-name']}>{item.categoriesName}</p>
              </Link>
            )
          })}
        </Carousel>
      </div>
    </>
  )
}

export default SecondCategory
